import { createApi } from '@reduxjs/toolkit/query/react';
import dayjs from 'dayjs';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';
import log from 'eslint-plugin-react/lib/util/log';

export const calendarApi = createApi({
  reducerPath: 'calendarApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    saveCalendarEvent: builder.mutation({
      query(req) {
        const formData = {
          ...req.body,
          from: dayjs(req.body.from).format('YYYY-MM-DDTHH:mm:ss+00:00'),
          to: req.body.to
            ? dayjs(req.body.to).format('YYYY-MM-DDTHH:mm:ss+00:00')
            : null,
        };
        if (req.id) {
          return {
            url: `${urls.calendar}/${req.id}`,
            method: 'PUT',
            data: formData,
          };
        } else {
          return {
            url: urls.calendar,
            method: 'POST',
            data: formData,
          };
        }
      },
    }),
    getCalendarEvents: builder.query({
      query: () => ({
        url: urls.calendar,
      }),
    }),
    getCalendarEvent: builder.query({
      query: (id) => ({
        url: `${urls.calendar}/${id}`,
      }),
    }),
    deleteCalendarEvent: builder.mutation({
      query(id) {
        return {
          url: `${urls.calendar}/${id}`,
          method: 'DELETE',
        };
      },
    }),
    importCalendarEvent: builder.mutation({
      query(req) {
        let packedData = new FormData(); // koli suboru musime poslat cez toto
        packedData.append('file', req.body.file);
        if (!!req.body.directory) {
          packedData.append('directory', req.body.directory);
        }

        return {
          url: urls.calendarImport,
          method: 'POST',
          data: packedData,
        };
      },
    }),
    getCalendarEventMonth: builder.query({
      query: (openedDate) => ({
        url: urls.calendarMonth(openedDate),
      }),
    }),
    getCalendarEventYear: builder.query({
      query: (displayedYear) => ({
        url: urls.calendarYear(displayedYear),
      }),
    }),
  }),
});

export const {
  useSaveCalendarEventMutation,
  useGetCalendarEventsQuery,
  useGetCalendarEventQuery,
  useDeleteCalendarEventMutation,
  useImportCalendarEventMutation,
  useGetCalendarEventMonthQuery,
  useGetCalendarEventYearQuery,
} = calendarApi;
